import { SET_GLOBAL_STATE, SET_ACTIVE_TYPES, TOGGLE_SELECTED_ITEM_TYPES, UPDATE_ITEMS_PAGE, REMOVE_NOTIFICATION, ADD_NOTIFICATION, SET_LOCALIZATION } from '../actions/actionTypes';

const initialState = {
    // conditional
    isLoginOpen: false,
    isSignupOpen: false,
    isMenuOpen: false,
    isMobileSearchOpen: false,
    isResultsOverviewActive: false,
    // values
    userRedirectPath: null,
    verifyEmail: null,
    activeCartItem: null,
    currentLocationAvailable: 'geolocation' in navigator && document.location.protocol === 'https:',
    activeSearchLocation: null,
    activeMainType: null,
    activeItemTypes: [],
    selectedItemTypeIds: [],
    pageNumber: 1,
    pageSize: 20,
    // others
    notifications: [],
    localization: {
        available: null,
        locale: null,
        language: null,
        region: null
    }
};

/* * * * * * * * * * * * * * * * * * * * * * * * *
* METHODS THAT UPDATE STATES WITH CORRECT VALUES *
* * * * * * * * * * * * * * * * * * * * * * * *  */
// set global state's value
const setGlobalState = (state, action) => {
    const updatedStates = Array.isArray(action.identifier) ? action.identifier.reduce((keys, currentKey) => {keys[currentKey] = typeof action.value !== 'undefined' ? action.value : false; return keys;}, {}) : 
        {[action.identifier]: typeof action.value !== 'undefined' ? action.value : !state[action.identifier]};

    return {...state, ...updatedStates};
};

// set actuve main item type or item type
const setActiveTypes = (state, action) => {
    return state.activeMainType !== action.mainType ? {...state, ...{
        activeMainType: action.mainType,
        activeItemTypes: action.itemTypes,
        selectedItemTypeIds: action.selectedItemTypeIds,
        pageNumber: 1
    }} : state;
};

// set selected item types
const updateSelectedItemTypes = (state, action) => {
    const updatedItemTypes = !!action.itemTypeId && state.selectedItemTypeIds.includes(action.itemTypeId) ?
        state.selectedItemTypeIds.filter(typeId => typeId !== action.itemTypeId) :
        !!action.itemTypeId ? state.selectedItemTypeIds.concat(action.itemTypeId) : [];

    return {...state, ...{
        selectedItemTypeIds: updatedItemTypes,
        pageNumber: 1
    }};
};

// update page number and page size for fetching items
const updateItemsPage = (state, action) => {
    return {...state, ...{
        pageNumber: action.number,
        pageSize: action.size
    }};
};

// NOTIFICATIONS
const addNotification = (state, action) => {
    // create notifications array that has previous notifications
    // create notification object that holds the passed data and add unique id
    let notificationId = false;
    let iterator = 0;
    const isExistingId = (id) => state.notifications.find(notification => notification.id === id);
    while (!notificationId || isExistingId(notificationId)) {
        notificationId = `${action.data.message.replace(/\s/g, '').substr(0, 5).toLowerCase()}_${state.notifications.length}${iterator ? '_' + iterator : ''}`;
        iterator++;
    }
    const notifyData = {
        id: notificationId,
        message: action.data.message,
        type: action.data.type,
        timeout: (action.data.timeout || (action.data.type === 'error' ? -1 : 5))
    };
    const updatedData = state.notifications.concat(notifyData);
    // add notification object to the array with previus notifications
    // updatedData.push(notifyData);
    return {...state, ...{
        notifications: updatedData
    }};
};

const removeNotification = (state, action) => {
    const updatedData = state.notifications.filter(notification => notification.id !== action.id);
    
    return {...state, ...{
        notifications: updatedData
    }};
};

// LOCALIZATION
const setLocalization = (state, action) => {
    const updatedLocalization = {...state.localization, ...{
        available: action.available,
        locale: action.locale,
        language: action.language,
        region: action.region
    }};

    return {...state, ...{
        localization: updatedLocalization
    }};
};

/* * * * * * * * *
* REDUCER METHOD *
* * * * * * * *  */
// Depending on the active action type, execute the correct function to update the correct states with the correct values
// Pass two parameters, first is the old state values, second is the new state values, these are passed from actions
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GLOBAL_STATE: return setGlobalState(state, action);
        case SET_ACTIVE_TYPES: return setActiveTypes(state, action);
        case TOGGLE_SELECTED_ITEM_TYPES: return updateSelectedItemTypes(state, action);
        case UPDATE_ITEMS_PAGE: return updateItemsPage(state, action);
        case ADD_NOTIFICATION: return addNotification(state, action);
        case REMOVE_NOTIFICATION: return removeNotification(state, action);
        case SET_LOCALIZATION: return setLocalization(state, action);
        default: return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/global.js